import { DesignIcon } from '@monorepo/nova-icons';
import { Button, Typography } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledNewOrderButtonText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.opposite,
  margin: 0,
  flex: 0,
  alignSelf: 'center',
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500,
  textTransform: 'none',
  '@media (max-width: 410px)': {
    fontSize: theme.typography.pxToRem(12),
  },

  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
  },
}));

export const StyledNewOrderButton = styled(Button)(({ theme }) => ({
  width: 'auto',
  height: 32,
  minWidth: 'auto',
  minHeight: 32,
  padding: '0 16px',
  alignItems: 'center',
  gap: 6,
  borderRadius: 30,
  background: theme.palette.primary.main,
  whiteSpace: 'nowrap',

  '@media (max-width: 410px)': {
    padding: '0 10px',
  },
  [theme.breakpoints.up('md')]: {
    width: 156,
    height: 42,
    minWidth: 156,
    minHeight: 42,
    padding: '0 24px',
  },
}));

export const StyledNewOrderButtonIcon = styled(DesignIcon)(({ theme }) => ({
  color: theme.palette.text.opposite,
  height: 16,
  width: 16,
  display: 'none',
  '@media (min-width: 510px)': {
    display: 'block',
  },
  [theme.breakpoints.up('md')]: {
    height: 20,
    width: 20,
  },
}));
